// src/utils/roleUtils.ts

const roleDisplayNames: Record<string, string> = {
  SUPER_ADMIN: "Super Admin",
  SALES_ADMIN: "Sales Admin",
  CONTENT_ADMIN: "Content Admin",
  TEAM_LEADER: "Team Leader",
  SALES_MANAGER: 'Sales Manager',
  SALES_TEAM_LEAD: 'Team Leader',
  SALES_EXECUTIVE: 'Executive',
  ENQUIRY_ADMIN: 'Enquiry Admin',
  SERVICE_ADMIN: 'Services Admin',
  PUBLISHER:'Publisher',
  JUNIOR_EDITOR:'Junior Editor',
  CHIEF_EDITOR:'Chief Editor',
  UPLOADER:'Uploader'
};
const serviceDisplayNames: Record<string, string> = {
  IVF:'IVF',
  IUI:'IUI',
  SURROGACY_CENTER:'Surrogacy Center',
  ICSI:'ICSI',
  SPERM_OR_EGG_FREEZING:'Sperm/ Egg freezing',
  ALL:'All',
  NEWS:'News',
  ARTICLE:'Articles',
  HOSPITAL: 'Hospital',
  INTERVIEW:'Interviews',
  REPORT:'Reports',
  WHITE_PAPER:'White Papers',
  WEBINAR:'Webinar',
  VIDEO:'Videos',
  WEEKLY:'Weekly Newsletter',
  MONTHLY:' Monthly Newsletter',
  THREE_TO_SIX_MONTHS:'3 - 6 Months',
  ONE_TO_THREE_MONTHS:'1 - 3 Months',
  FLEXIBLE:'Flexible',
  IMMEDIATE:'Immediate',
  FEMALE:'Female',
  MALE:'Male',
  OTHERS:'Other',
  EVENT:'Events',
  ASSOCIATE:'Associate',
  MANUFACTURING:'Manufacturing',
  MID_LEVEL:'Mid Level',
  CUSTOMER_SERVICE:'Customer Service',
  FINANCE:'Finance',
  ENTRY_LEVEL:'Entry Level',
  ADMINISTRATION:'Administration',
  PROJECT_MANAGEMENT:'Project Management',
  PHARMACEUTICALS:'Pharmaceuticals',
  SENIOR_LEVEL:'senior Level',
  QUALITY_ASSURANCE:'Quality Assurance',
  INFORMATION_TECHNOLOGY:'Information Technology',
  FINANCE_OR_ACCOUNTING:'Finance or Accounting',
  BUSINESS_DEVELOPMENT:'Business Development',
  HEALTHCARE:'Healthcare',
  CONSULTING:'Consulting',
  RETAIL:'Retail',
  MANAGER:'Manager',
  INTERN:'Intern',
  HUMAN_RESOURCES:'Human Resources',
  OWNER_OR_FOUNDER:'Owner or Founder',
  TRAINING_AND_DEVELOPMENT:'Training and Development',
  PROSPECT: 'Prospect',
  READER: 'Reader',
  BUYER: 'Buyer'
};
const roleNames: Record<string, string> = {
  COMPANY: "Company",
  EVENT_ORGANIZER: "Event Organiser",
  HOSPITAL: "Hospital",
  READER:'Reader',
  VENDOR:'Vendor'
}
const leadsType: Record<string, string> = {
  COMPANY: "Company",
  EVENT_ORGANIZER: "Event Organiser",
  HOSPITAL: "Hospital",
  MEDIA_AGENCY: "Media Agency",
  DIGITAL_AGENCY: 'Digital Agency',
  PR_AGENCY: 'PR Agency',
  PAID:'Paid',
  TRIAL:'Trial',
  INVITE:'Invite',
  BARTER:'Barter',
  EVENT: 'Event Organiser'
};
const leadsTypes: Record<string, string> = {
  COMPANY: "(Company)",
  EVENT_ORGANIZER: "(Event Organiser)",
  HOSPITAL: "(Hospital)",
  
};
const shotRolesName:Record<string ,string>={
  JUNIOR_EDITOR:' (JE)',
  CHIEF_EDITOR:' (CE)',
  PUBLISHER:' (PUBL)',
  UPLOADER:' (UL)'
}
const getSubManager: Record<string, string> = {
  SALES_TEAM_LEAD: "Sales Manager",
  SALES_EXECUTIVE: 'Team Leader',
};
const getleadType:Record<string,string>={
  COMPANY:'Company Name',
  EVENT_ORGANIZER:'Event Organiser Name',
  HOSPITAL:'Hospital Name',
}
const getCompanyType:Record<string,string>={
  COMPANY:'Company Name',
  EVENT:'Event Organiser Name',
  HOSPITAL:'Hospital Name'
}
const getEventType:Record<string,string> = {
  VIRTUAL:'Remote',
  VENUE:'Venue'
}
const statusName:Record<string, string> = {
  ACTIVATED: "Active",
  ACTIVE:'Active',
  CONFIRM:'Confirm',
  DEACTIVATE: "Inactive",
  SENT: "Yet to Accept",
  EXPIRED: "Expired",
  CANCELED: "Cancelled",
  NONE: 'None',
  BOOKED: 'Booked',
  DECLINED: 'Declined',
  PUBLISHED: 'Published',
  SAVED_AS_DRAFT:'Draft',
  ASSIGNED_TO_PUBLISHER:'Assigned to Publisher',
  TO_PUBLISHER_APPROVE:'Sent for Approval to Publisher',
  TO_CE_APPROVE:'Sent for Approval to CE',
  TO_JE_APPROVE: 'Sent for Approval to JE',
  ASSIGNED_TO_JE: "Assigned to JE",
  AWAITING_APPROVAL:'Awaiting approval',
  ARCHIVED:'Archived',
  APPROVED: 'Approved',
  SAVE_AS_DRAFT: 'Draft'
  // ASSIGNED_TO_PUBLISHER: 'Assigned to Publisher',
};
const paymentStatusName:Record<string,string>={
  YET_TO_SIGN:'Draft Proposal ',
  NOTGENERATED:'Not Generated',
  UNPAID:'Un Paid',
  ACTIVE:'Active',
  CONFIRM:'Under Review',
  DECLINED:'Declined',
  YET_TO_APPROVE:'Yet to Approve',
  EXPIRED:'Expired',
  PAID:'Paid'
}
const statusNames: Record<string, string> = {
  ACTIVATED: "Active",
  YET_TO_SIGN:'Draft Proposal ',
  NOTGENERATED:'Not Generated',
  ACTIVE:'Active',
  CONFIRM:'Confirm',
  DEACTIVATE: "Inactive",
  SENT: "Yet to Accept",
  EXPIRED: "Invitation Expired",
  CANCELED: "Invitation Cancelled",
  NONE: 'None',
  BOOKED: 'Booked',
  DECLINED: 'Declined',
  PUBLISHED: 'Published',
  SAVED_AS_DRAFT:'Draft',
  TO_PUBLISHER_APPROVE:'Sent for Approval to Publisher',
  TO_CE_APPROVE:'Sent for Approval to CE',
  TO_JE_APPROVE: 'Sent for Approval to JE',
  ASSIGNED_TO_JE: "Assigned to JE",
  AWAITING_APPROVAL:'Awaiting approval',
  ARCHIVED:'Archived',
  APPROVED: 'Approved',
  SAVE_AS_DRAFT: 'Draft',
  HOSPITAL_PROFILING: "Hospital Profiling",
  CENTER_LISTING: "Center Listing",
  BANNER_ADS: "Banner Advertisements",
  EMAIL_MARKETING: "Email Marketing",
  NEWS_LETTER_ADS: "Ads in e-newsletter",
  CONTENT_MARKETING: "Content Marketing",
  PRINT_AD: "Print Advertisement",
  COMPANY_PROFILING: "Company Profiling",
  EVENT_PROFILING: "Event Profiling",
  EVENT_LISTING: "Event Listing",

  ASSIGNED_TO_PUBLISHER: 'Assigned to Publisher',
};

const LeadBookingStatus : Record<string,string>= {
  ACTIVE:'Active',
  CONFIRM: 'Confirmed',
  EXPIRED:'Expired'
}


const shiftDisplayNames: Record<string, string> = {
  SHIFT_A: 'Shift A',
  SHIFT_B: 'Shift B',
  "SMALL":'Small',
    'MEDIUM':'Medium',
    "LARGE":'Large',
    "IVF_TREATMENT":'IVF Treatment',
    "IUI_TREATMENT" :'IUI Treatment',
    "SURROGACY":'Surrogacy',
    "FERTILITY_PRESERVATION":'Fertility Preservation',
    "FERTILITY_TESTING":'Fertility Testing',
    "SPERM_OR_EGG_FREEZING":'Egg/Sperm Freezing Treatment'
}
export function getServiceyName(roleName: any) {
  return serviceDisplayNames[roleName] || roleName;
}

export function getRoleShot(name:string){
  return shotRolesName[name] || '';
}
export function getNamesOfEvents(name:string){
  return getleadType[name] || name;
}
export function getNamesOfCompany(name:string){
  return getCompanyType[name] || name;
}
export function getEventTypes(name:string){
  return getEventType[name] || name;
}
export function getSubRoleDisplayName(roleName: any) {
  return getSubManager[roleName] || roleName;
}
export function getRoleDisplayName(roleName: any) {
  return roleDisplayNames[roleName] || roleName;
}
export function getDisplayCompany(roleName: any) {
  return leadsType[roleName] || roleName;
}
export function getDisplayType(roleName: any) {
  console.log(roleName)
  return leadsTypes[roleName] || '';
}
export function getDisplayCompanys(roleName:any){
  return roleNames[roleName] || 'Guest';
}
export function getDisplayCompan(roleName:any){
  return roleNames[roleName];
}
export function getSHiftDisplayName(name: any) {
  return shiftDisplayNames[name] || name;
}
export function getStatusDisplayName(status: any) {
  return statusNames[status] || status;
}
export function getStatusDisplayNames(status:any){
  return paymentStatusName[status] || status;
}

export function getStatusDisName(status: any) {
  return statusName[status] || status;
}
export function getBookStatus(status: any) {
  return LeadBookingStatus[status] || status;
}
export function getStatusClasses(status:any){
  switch (status){
 case 'YET_TO_SIGN':
      return 'bg-[#E3F2FD] text-[#1565C0]';
      case 'ACTIVE':
        return 'bg-[#D1FAE5] text-[#065F46]';
      case 'CONFIRM':
          return 'bg-[#FFF3CD] text-[#856404]';
          case 'UNPAID':
        return 'bg-[#FEE2E2] text-[#991B1B]';
        case 'EXPIRED':
      return 'bg-[#FEE2E2] text-[#991B1B]';
        case 'NOTGENERATED':
        return 'bg-[#F2F4F7] text-[#364254]';
        case 'DECLINED':
          return 'bg-[#FEE2E2] text-[#991B1B]';
          default:
      return ''; 
  }
 
}
export function getDotColors(status: any) {
  switch (status) {
    case 'YET_TO_SIGN':
      return '#1565C0';
      case 'DECLINED':
        return '#F87171';
    case 'ACTIVATED':
      return '#14BA6D'; // Green
      case 'NOTGENERATED':
        return '#6C778B';
        case 'UNPAID':
          return '#F87171';
    case 'APPROVED':
      return '#34D399';
    case 'CONFIRM':
        return '#856404';
      case 'ACTIVE':
        return '#34D399';
        case 'EXPIRED':
          return '#F87171'; 
          
    default:
      return ''; // Default gray
  }
};
export function getStatusClass(status: any) {
  switch (status) {
    case 'ACTIVATED':
      return 'bg-[#D1FAE5] text-[#065F46]';
      case 'YET_TO_SIGN':
      return 'bg-[#E3F2FD] text-[#1565C0]';
    case 'APPROVED':
      return 'bg-[#D1FAE5] text-[#065F46]';
      case 'UNPAID':
        return 'bg-[#FEE2E2] text-[#991B1B]';
    case 'ACTIVE':
      return 'bg-[#D1FAE5] text-[#065F46]';
       case 'NOTGENERATED':
        return 'bg-[#F2F4F7] text-[#364254]'
    case 'CONFIRM':
        return 'bg-[#D1FAE5] text-[#065F46]';
    case 'DEACTIVATE':
      return 'bg-[#F3F4F6] text-gray-800';
    case 'EXPIRED':
      return 'bg-[#FEE2E2] text-[#991B1B]';
    case 'SENT':
      return 'bg-[#DBEAFE] text-[#1E40AF]';
    case 'CANCELED':
      return 'bg-[#FCE7F3] text-[#9D174D]';
    case 'BOOKED':
      return 'bg-[#D1FAE5] text-[#065F46]';
    case 'DECLINED':
      return 'bg-[#FEE2E2] text-[#991B1B]';
    case 'PUBLISHED':
      return 'bg-[#D1FAE5] text-[#065F46]';
    case 'NONE':
      return 'bg-[#F3F4F6] text-gray-800';
    case 'SAVED_AS_DRAFT':
      return 'bg-[#F3F4F6] text-gray-800';
    case 'SAVE_AS_DRAFT':
      return 'bg-[#F3F4F6] text-gray-800';
    case 'TO_PUBLISHER_APPROVE':
      return 'bg-[#DBEAFE] text-[#1E40AF]';
      case 'TO_JE_APPROVE':
     return 'bg-[#DBEAFE] text-[#1E40AF]';
     case  'ASSIGNED_TO_JE':
      return 'bg-[#DBEAFE] text-[#1E40AF]';
    case 'TO_CE_APPROVE':
      return 'bg-[#DBEAFE] text-[#1E40AF]'
    case 'ASSIGNED_TO_PUBLISHER':
      return 'bg-[#DBEAFE] text-[#1E40AF]'
    case 'AWAITING_APPROVAL':
      return 'bg-[E33E5FBF] text-[#374151]';
    case 'ARCHIVED':
        return 'bg-[#EDE9FE] text-[#5B21B6]';
    default:
      return ''; // Default case if status doesn't match any known status
  }
};

export function getDotColor(status: any) {
  switch (status) {
    case 'ACTIVATED':
      return '#34D399'; // Green
       case 'YET_TO_SIGN':
      return '#1565C0'
      case 'NOTGENERATED':
        return '#6C778B';
    case 'APPROVED':
      return '#34D399';
      case 'UNPAID':
        return '#F87171';
    case 'CONFIRM':
        return '#34D399';
    case 'DEACTIVATE':
      return '#4B5563'; // Gray
    case 'EXPIRED':
      return '#F87171'; // Red
    case 'SENT':
      return '#60A5FA'; // Blue
    case 'CANCELED':
      return '#F472B6'; // Pink/Red
      case 'BOOKED':
        return '#34D399'; 
      case 'DECLINED':
        return '#F87171';
      case 'PUBLISHED':
        return '#34D399';
      case 'NONE':
        return '#4B5563';
      case 'SAVED_AS_DRAFT':
        return '#4B5563'
      case 'SAVE_AS_DRAFT':
        return '#4B5563'
      case 'TO_PUBLISHER_APPROVE':
        return '#1E40AF'
      case 'TO_CE_APPROVE':
        return '#1E40AF'
      case 'TO_JE_APPROVE':
        return '#1E40AF'
      case 'ASSIGNED_TO_JE':
        return '#1E40AF'
        case 'ASSIGNED_TO_PUBLISHER' :
          return '#1E40AF'
      case 'ACTIVE':
        return '#34D399';
          
    default:
      return ''; // Default gray
  }
};
export function getCurrencySymbol(currencyCode: string | number) {
  console.log(currencyCode);

  switch (currencyCode) {
    case '2':
      return '₹';
    case 2:
      return '₹';
    case '1':
      return '$';
    case 1:
      return '$';
    case '3':
      return '€';
    case 3:
      return '€';
    case '4':
      return '£';
    case 4:
      return '£';
    default:
      return '₹'; // Fallback if no match is found
  }
};
